export const AIMusicGeneratorStoreName = 'ai-music-generator'
